import axios from 'axios'
const ZYC_ROOT = import.meta.env.VITE_SWOOLE_ROOT

// getInspectionReport
// - 2023.06.20
export const getInspectionReport = async ({params}) => {
  try {
    const url = `${ZYC_ROOT}/v1/vehicleInspection/report`
    const res = await axios.get(url, {
      params,
    })

    if (res.status === 200){
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getInspectionReportFlaw
// - 2023.06.21
export const getInspectionReportFlaw = async ({params}) => {
  try {
    const url = `${ZYC_ROOT}/v1/vehicleInspection/flaw`
    const res = await axios.get(url, {
      params,
    })

    if (res.status === 200){
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getInspectReportMileage
// - 2023.06.27
export const getInspectReportMileage = async ({params}) => {
  try {
    const url = `${ZYC_ROOT}/v1/vehicleInspection/mileage`
    const res = await axios.get(url, {
      params,
    })

    if (res.status === 200){
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getReportInspection
// - 2024.04.02
export const getReportInspection = async ({params}) => {
  try {
    const url = `${ZYC_ROOT}/v1/vehicleInspection/appraise`
    const res = await axios.get(url, {
      params,
    })

    if (res.status === 200){
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getReportInspectionFields
// - 2024.12.19
// - Get report inspection fields
export const getReportInspectionFields = async ({params}) => {
  try {
    const url = `${ZYC_ROOT}/v1/vehicleInspection/appraise/checkPoints`
    const res = await axios.get(url, {
      params,
    })

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getReportInspectionFieldDetail
// - 2024.12.19
// - Get report inspection field detail
export const getReportInspectionField = async ({params}) => {
  try {
    const url = `${ZYC_ROOT}/v1/vehicleInspection/appraise/checkPointItem`
    const res = await axios.get(url, {
      params,
    })

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getReportInspectionPreview
// - 2025.05.16
// - Get report inspection preview
export const getReportInspectionPreview = async ({params}) => {
  try {
    const url = `${ZYC_ROOT}/v1/vehicleInspection/appraise/forestall`
    const res = await axios.get(url, {
      params,
    })

    if (res.status === 200) {
      return res.data
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}
